import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  IconDefinition,
  faBook,
  faBooks,
  faGraduationCap,
} from '@fortawesome/pro-solid-svg-icons'
import { Link } from 'react-router-dom'
import styles from './empty-state-section.module.scss'

interface Props {
  link?: {
    text: string
    href: string
  }
  text: string
  variant?: keyof typeof variantIcons
}

const variantIcons: Record<string, IconDefinition> = {
  default: faBooks,
  learningPaths: faGraduationCap,
  categories: faBook,
}

export const EmptyStateSection = ({ text, link, variant }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <div className={styles.icon}>
          <FontAwesomeIcon
            icon={variant ? variantIcons[variant] : variantIcons.default}
          />
        </div>
      </div>
      <div className={styles.text}>{text}</div>
      {link && (
        <Link className={styles.link} to={link.href}>
          {link.text}
        </Link>
      )}
    </div>
  )
}
